<label 
    class="base-input-container {{inputBorderClasses[borderStyle]}} {{size}}"
    [for]="formControlName" 
    [ngClass]="{'focused': inputFocused, 'disabled': disabled, 'readonly': readonly, 'processing': processing, 'error': error}"
    (click)="handleMainClick()">
    <!-- Prefix -->
    <div *ngIf="!!title" class="input-title"><span>{{title}}</span></div>
    <div *ngIf="!!prefix" class="input-prefix"><span>{{prefix}}</span></div>
    <input 
        [attr.name]="formControlName" 
        [attr.type]="type"
        [attr.placeholder]="placeholder" 
        [value]="value" 
        [(ngModel)]="value" 
        class="input" 
        (change)="handleChange($event)"
        (focus)="onInputFocus($event)"
        (focusout)="onInputFocusOut($event)"
        [disabled]="disabled || processing ? true : false"
        [attr.readonly]="readonly ? '' : null" 
        [attr.invalid]="error ? '' : null" 
        [attr.autocapitalize]="autocapitalize" 
        [attr.maxlength]="maxLength" 
        min="1"
        [attr.max]="max" 
        [attr.autocomplete]="autocomplete" 
        #input>
    <!-- Suffix -->
    <div *ngIf="!!suffix" class="input-suffix" translate [translateParams]="{count: value}">{{suffix}}</div>
    <!-- Suffix icon -->
    <div *ngIf="!!iconClass && !disabled" class="input-suffix input-icon {{iconClass}}" (click)="toggleIcon()" [display]="!!tooltipContent"
        [appSmashTooltip]="informationsTooltipTemplate" contentType="template" [placement]="defaultTooltipDirection" [autoPlacement]="true" hide-delay="100" 
        theme="light">
    </div>
</label>

<ng-content select="[error]"></ng-content>

<ng-template #informationsTooltipTemplate>
    <div class="tooltip-content">
        {{tooltipContent}}
    </div>
</ng-template>